import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';

import "../../../../assets/css/style.css";
import Form from "./Form.js";
import ContentWithImages from "./ContentWithImages.js";
import DoctorBite from "../../DoctorBite.js";
import PatientReviews from "../../PatientReview.js";
import GetInTouch from "../../GetInTouch.js";
import FollowYt from "../../FollowYt.js";
import Counter from "../../../NumCounter.js";
import Breadcrumb from "../../Breadcrum.js";

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
      <Helmet>
      <title>Epistaxis Treatment in Delhi, India | Nosebleed Surgery, Cost, Doctor, Clinic</title>
      <meta name="description" content="Get safe and effective Epistaxis (Nosebleed) treatment and surgery  in Delhi, India. Learn about the causes, procedures, and costs at top ENT hospitals and clinics, including MedFirst ENT Centre." />
      <meta name="keywords" content="ENT surgery Delhi, ear nose throat surgery, best ENT surgeon, ENT clinic Delhi" />
      <link rel="canonical" href="https://entdelhi.com/epistaxis/" />
            <meta property="og:title" content="Epistaxis Treatment in Delhi, India | Nosebleed Surgery, Cost, Doctor, Clinic" />
      <meta property="og:description" content="Get safe and effective Epistaxis (Nosebleed) treatment and surgery  in Delhi, India. Learn about the causes, procedures, and costs at top ENT hospitals and clinics, including MedFirst ENT Centre." />
      <meta name="robots" content="index, follow" />
      {/* You can add more meta tags as needed */}
    </Helmet>
     <main>
        <Breadcrumb/>
        <Form />  
        <Counter />
        <ContentWithImages />
        <FollowYt />
        <DoctorBite />
        <PatientReviews />
        <GetInTouch />
      </main>
    </div>
  );
}
